const WholeRest = ({x, y, width, height}) => {
    return (
        <g fill="#000000">
            <rect x={x} y={y} width={width} height={height}/>
        </g>
    )
}

export default WholeRest